export default "__VITE_ASSET__73c4001d__"